// Evaluation Headers / Edit
(() => {
  'use strict';

  /* ************************************************** */
  /* ******************** VAR/CONST ******************* */
  /* ************************************************** */
  const intLabels = {
    es: {
      messages: {
        node_not_fully_qualified: "No se califico por completa esta sección, ¿desea continuar?",
        questionnaire_not_finished: "Hay preguntas dentro de la FESP que faltan por responder, por favor verifique las secciones."
      }
    },
    en: {
      messages: {
        node_not_fully_qualified: "This section was not fully rated, you want to continue?",
        questionnaire_not_finished: "There are questions within the FESP that remain to be answered, please check the sections."
      }
    }
  };

  /* ************************************************** */
  /* ***************** TURBOLINKS LOAD **************** */
  /* ************************************************** */
  document.addEventListener('turbolinks:load', async event => {
    if (document.getElementById("questions")) {
      await treeEvaluation.initialize();
      trigAnswerSelected();
      observeCommentsOpenHide();
      observeButtonSave();
      observeButtonNext();
      observeButtonPrev();
      observeButtonHidden();
      observeButtonParticipants();
    }
  });

  /* ************************************************** */
  /* ***************** EVENT TRIGGERS ***************** */
  /* ************************************************** */
  //
  let trigAnswerSelected = () => {
    document.body.addEventListener('change', event => {
      if (event.target.getAttribute('type') === 'radio' || event.target.getAttribute('type') === 'checkbox') {
        removeResponseNotApplying(event.target);
        answerDependentQuestions(event.target);
        updateProgressCounter(event.target.getAttribute('data-parent'));
        saveAnswersTemporatily(event.target.getAttribute('data-parent'));
      }
    });
  };

  //
  let observeButtonHidden = () => {
    try {
      document.getElementById('toggle-tree-filter').addEventListener('click', event => {
        let icon = document.querySelector('#toggle-tree-filter svg');
        if (icon.classList.contains('fa-toggle-on')) {
          icon.classList.remove('fa-toggle-on');
          icon.classList.add('fa-toggle-off');
        } else {
          icon.classList.remove('fa-toggle-off');
          icon.classList.add('fa-toggle-on');
        }
        document.getElementById('column-tree-filter').classList.toggle('d-none');
      });
    } catch (error) {
      error;
    }
  };

  //
  let observeButtonNext = () => {
    try {
      document.getElementById('btn-next').addEventListener('click', async event => {
        await treeEvaluation.save();
        treeEvaluation.changeChild();
        treeEvaluation.changeLabelSaveButton();
      });
    } catch (error) {
      error;
    }
  };

  //
  let observeButtonParticipants = () => {
    try {
      document.getElementById('toggle-participants').addEventListener('click', event => {
        let icon = document.querySelector('#toggle-participants svg');
        if (icon.classList.contains('fa-users')) {
          icon.classList.remove('fa-users');
          icon.classList.add('fa-users-slash');
        } else {
          icon.classList.remove('fa-users-slash');
          icon.classList.add('fa-users');
        }
        document.getElementById('form-participants').classList.toggle('d-none');
      });
    } catch (error) {
      error;
    }
  };

  //
  let observeButtonPrev = () => {
    try {
      document.getElementById('btn-prev').addEventListener('click', async event => {
        await treeEvaluation.save();
        treeEvaluation.changeChild('prev');
        treeEvaluation.changeLabelSaveButton();
      });
    } catch (error) {
      error;
    }
  };

  //
  let observeButtonSave = () => {
    try {
      document.getElementById('btn-save').addEventListener('click', async event => {
        let current_child = document.querySelector('.child-tree.active').getAttribute('data-child'),
            total_qualified = parseInt(document.getElementById(`child_evaluated_questions_${current_child}`).innerHTML),
            total_questions = parseInt(document.getElementById(`child_total_questions_${current_child}`).innerHTML);
        
        await treeEvaluation.save();
        if (total_qualified === total_questions) {
          treeEvaluation.changeChild();
          validCompleteSurvey();
        } else {
          if (total_qualified > 0) {
            document.getElementById('layer-loading-tree').classList.toggle('d-none');
            location.reload();
          }
        }
      });
    } catch (error) {
      error; 
    }
  };

  //
  let observeCommentsOpenHide = () => {
    $('#observations-modal').on('show.bs.modal', event => {
      document.getElementById('observations-modal').setAttribute('data-question', event.relatedTarget.getAttribute('data-question'));
      document.getElementById('observations_questions').value = document.getElementById(`observations_${event.relatedTarget.getAttribute('data-question')}`).innerHTML;
      document.getElementById('question-modal-text').innerHTML = event.relatedTarget.getAttribute('data-question-text');
    })
    .on('hide.bs.modal', e => {
      let question = document.getElementById('observations-modal').getAttribute('data-question'),
          observation = document.getElementById(`observations_${question}`);

      observation.innerHTML = document.getElementById('observations_questions').value;
      saveAnswersTemporatily(observation.getAttribute('data-parent'));
    });
  };

  /* ************************************************** */
  /* ****************** DOM MODIFIERS ***************** */
  /* ************************************************** */
  //
  let answerDependentQuestions = answer => {
    let value = answer.value;

    if (answer.getAttribute('data-dependants') && answer.getAttribute('data-dependants') !== "") {
      answer.getAttribute('data-dependants').split(',').forEach(question => {
        document.querySelector(`[id=answer_${question}][value="${value}"]`).checked = true;
        if (document.querySelector(`[id=does_not_apply_${question}]`))
          document.querySelector(`[id=does_not_apply_${question}]`).checked = false;
      });
    }

    answerDependentQuestionsNotApply(answer);
  };

  //
  let answerDependentQuestionsNotApply = not_apply => {
    if (not_apply.getAttribute('name') === 'does_not_apply') {
      let total_answer_dependats = 0,
          current_question = not_apply.getAttribute('data-question');

      document.querySelectorAll(`input[name=answer_${current_question}]`).forEach(answer => {
        if (answer.getAttribute('data-dependants') !== '')
          total_answer_dependats += 1;
      });

      if (total_answer_dependats === 1) {
        document.querySelectorAll(`input[name=answer_${current_question}][data-dependants]:not([data-dependants=""])`)[0].getAttribute('data-dependants').split(',').forEach(question => {
          if (document.getElementById(`does_not_apply_${question}`)) {
            document.getElementById(`does_not_apply_${question}`).checked = true;
            if (document.querySelectorAll(`input[name=answer_${question}]:checked`).length > 0)
              document.querySelectorAll(`input[name=answer_${question}]:checked`)[0].checked = false;
          }
        });
      }
    }
  };

  //
  let removeResponseNotApplying = current_element => {
    let type = current_element.getAttribute('type'),
        question = current_element.getAttribute('data-question');

    if (type === 'checkbox') {
      let answer = document.querySelector(`input[type=radio][data-question="${question}"]:checked`);

      try {
        answer.checked = false;
      } catch (error) {
        answer;
      }
    } else {
      let not_apply = document.querySelector(`input[type=checkbox][data-question="${question}"]`);

      try {
        not_apply.checked = false;
      } catch (error) {
        not_apply;
      }
    }
  };

  //
  let updateProgressCounter = content_id => {
    let total_checked = 0;
    try {
      document.querySelectorAll(`input[type='radio'][data-parent='${content_id}']`).forEach(el => {
        if (el.checked)
          total_checked += 1;
      });
  
      document.querySelectorAll(`input[type='checkbox'][data-parent='${content_id}']`).forEach(el => {
        if (el.checked)
          total_checked += 1;
      });
  
      document.getElementById(`child_evaluated_questions_${content_id}`).innerHTML = total_checked;
    } catch (error) {
      console.log(error);
    }
    
    updateProgressCounterParent(document.getElementById(`children${content_id}`).getAttribute('data-parent'));
  };

  //
  let updateProgressCounterParent = parent => {
    let progress = 0;
    try {
      document.querySelectorAll(`.child-tree[data-parent='${parent}']`).forEach(el => {
        progress += parseInt(el.querySelector('span span').innerHTML)
      });  
    } catch (error) {
      console.log(error);
      progress;
    }
    
    document.getElementById(`parent_evaluated_questions_${parent}`).innerHTML = progress;
  };

  /* ************************************************** */
  /* ******************** FUNCTIONS ******************* */
  /* ************************************************** */
  // Get attribute LANG from html tag
  let getLanguage = () => document.getElementsByTagName('html')[0].getAttribute('lang');

  //
  let saveAnswersTemporatily = (parent) => {
    try {
      let evaluation = document.getElementById('evaluation-header').getAttribute('data-evaluation-header');
      localStorage.setItem(`${evaluation}_unsaved_questions_${parent}`, JSON.stringify(treeEvaluation.questionsAnswered()));
    } catch (error) {
      console.log(error);
    }
  }

  //
  let validCompleteSurvey = () => {
    let total_qualified = 0,
        total_questions = 0,
        last_parent = document.querySelector('.card:last-child .card-header').getAttribute('id'),
        last_child = document.querySelector('.card:last-child').querySelector('.child-tree:last-child').getAttribute('id'),
        selected_parent = document.querySelector('.card-header.parent-active').getAttribute('id'),
        selected_child = document.querySelector('.child-tree.active').getAttribute('id');

    if (last_parent === selected_parent && last_child === selected_child) {
      document.querySelectorAll('[id^="parent_evaluated_questions_"]').forEach(el => total_qualified += parseInt(el.innerHTML));
      document.querySelectorAll('[id^="parent_total_questions_"]').forEach(el => total_questions += parseInt(el.innerHTML));

      if (total_qualified === total_questions) {
        location.href = location.toString().replace('/edit', '');
      } else {
        swal(intLabels[getLanguage()].messages.questionnaire_not_finished);
      }
    }
  };
})();